const REQUIRED_FIELD_MARK = (
  <span className="text-danger" aria-hidden="true"> *</span>
);

const ExpenseFormItem = ({ data, label, show, alwaysUseMobileStyling, requiredMark, children }) => {
  const isMobile = data.isMobile || alwaysUseMobileStyling;

  return (
    <div className={`${isMobile ? 'flex-column mb-3' : 'mb-2'}`} style={{ display: show ? 'flex' : 'none' }}>
      <div className={`font-weight-bold ${isMobile ? 'text-primary mb-1' : 'col-3 align-self-center'}`}>
        { label }{ requiredMark ? REQUIRED_FIELD_MARK : null }{ isMobile ? '' : ' :' }
      </div>
      <div className={`invoice-value ${isMobile ? "" : "col-6"}`}>
        { children }
      </div>
    </div>
  );
};

export default ExpenseFormItem;
